import React from 'react';
import { Stepper, Step, StepLabel, Box, useTheme, useMediaQuery } from '@mui/material';
import { STATUS_FLOW, STATUS_COLORS } from '../../config/constants';

const StudentStatusStepper = ({ currentStatus }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const currentIndex = STATUS_FLOW.indexOf(currentStatus);

  // If current status is not in the main flow (e.g. Rejected, Cancelled, Hold),
  // we still show the flow but without an active step highlight.
  const activeStep = currentIndex >= 0 ? currentIndex : -1;

  return (
    <Box sx={{ width: '100%', overflowX: 'auto', py: 2 }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel={!isMobile}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        sx={{ minWidth: isMobile ? 'auto' : 700 }}
      >
        {STATUS_FLOW.map((status, index) => {
          const isCompleted = activeStep >= 0 && index < activeStep;
          const isCurrent = index === activeStep;
          const color = STATUS_COLORS[status] || '#9e9e9e';

          return (
            <Step key={status} completed={isCompleted}>
              <StepLabel
                StepIconProps={{
                  sx: {
                    ...(isCompleted && {
                      color: `${color} !important`,
                    }),
                    ...(isCurrent && {
                      color: `${color} !important`,
                      '& .MuiStepIcon-text': {
                        fill: '#fff',
                        fontWeight: 700,
                      },
                    }),
                  },
                }}
                sx={{
                  '& .MuiStepLabel-label': {
                    fontSize: '0.7rem',
                    fontWeight: isCurrent ? 700 : 400,
                    color: isCurrent ? color : 'text.secondary',
                    mt: 0.5,
                  },
                }}
              >
                {status}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>

      {/* Show off-flow status if applicable */}
      {activeStep === -1 && currentStatus && (
        <Box
          sx={{
            mt: 2,
            textAlign: 'center',
            py: 1,
            px: 2,
            borderRadius: 1,
            backgroundColor: STATUS_COLORS[currentStatus]
              ? `${STATUS_COLORS[currentStatus]}20`
              : 'grey.100',
            color: STATUS_COLORS[currentStatus] || 'text.primary',
            fontWeight: 600,
            fontSize: '0.875rem',
          }}
        >
          Current Status: {currentStatus}
        </Box>
      )}
    </Box>
  );
};

export default StudentStatusStepper;
